/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './roles.reducer';

export const RolesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const rolesEntity = useAppSelector(state => state.roles.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="rolesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.roles.detail.title">Roles</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.roles.id">Id</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.id}</dd>
          <dt>
            <span id="roleType">
              <Translate contentKey="tinyMedicRestApp.roles.roleType">Role Type</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.roleType}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.roles.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.roles.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.roles.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.roles.active">Active</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.roles.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{rolesEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/roles" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/roles/${rolesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RolesDetail;
